export default __webpack_public_path__ + "static/floor1-slide-2-f4f4b988d151450bee8aeb61fb93eeb7.jpg";